export const getSasQuery = (container) => {
  return `{
    getStorageKey(container: "${container}") {
      key
    }
  }`
}
